import type { Row } from '@tanstack/react-table';
import { DateTime } from '@ksyos/date-time';

export function dateAfterFilter<T>(row: Row<T>, columnId: string, filterValue: string) {
    const rowValue = row.getValue(columnId);

    if (!filterValue) {
        return true;
    }

    if (!rowValue) {
        return false;
    }

    const rowDate = DateTime.from(rowValue.toString());
    const filterDate = DateTime.from(filterValue);

    return rowDate.isAfter(filterDate);
}
